// Original SVG scene illustrations for CPR University lessons.
// Each scene features a CPR rep character (in a CPR4homes polo) + a homeowner where relevant.
// Colorful and varied per section. All hand-built — no external/copyrighted assets.

const POLO = '#0D3B2E', GOLD = '#c9a227', SKIN = '#e8b48c', SKIN2 = '#d89b6e';

function Rep({ x, y, female = false, flip = false }) {
  return (
    <g transform={`translate(${x},${y}) scale(${flip ? -1 : 1},1)`}>
      <path d="M-11 26 q0 -15 11 -15 q11 0 11 15 l0 6 -22 0 z" fill={POLO} />
      <path d="M-4 11 L0 17 L4 11" fill="none" stroke={GOLD} strokeWidth="2" />
      <text x="0" y="26" fontSize="4.5" fontWeight="800" fill={GOLD} textAnchor="middle" transform={flip ? 'scale(-1,1)' : ''}>CPR</text>
      <rect x="-2.6" y="5" width="5.2" height="7" fill={SKIN2} />
      <circle cx="0" cy="0" r="8.5" fill={SKIN} />
      {female
        ? <path d="M-8.5 -1 a8.5 8.5 0 0 1 17 0 q1.5 11 -3 13 l-1.5 -10 -8 0 -1.5 10 q-4.5 -2 -3 -13z" fill="#5a3c22" />
        : <path d="M-8.5 -1 a8.5 8.5 0 0 1 17 0 q-2.5 -5 -8.5 -5 q-6 0 -8.5 5z" fill="#3a2a1a" />}
      <circle cx="-3" cy="0.5" r="1.1" fill="#333" /><circle cx="3" cy="0.5" r="1.1" fill="#333" />
      <path d="M-3 4 q3 2.5 6 0" stroke="#a85f3a" strokeWidth="1" fill="none" strokeLinecap="round" />
    </g>
  );
}

function Homeowner({ x, y, color = '#c98a8a', flip = false }) {
  return (
    <g transform={`translate(${x},${y}) scale(${flip ? -1 : 1},1)`}>
      <path d="M-10 24 q0 -14 10 -14 q10 0 10 14 l0 6 -20 0 z" fill={color} />
      <rect x="-2.4" y="5" width="4.8" height="6" fill={SKIN2} />
      <circle cx="0" cy="0" r="8" fill={SKIN} />
      <path d="M-8 -2 a8 8 0 0 1 16 1 q-3 -6 -8 -6 q-5 0 -8 5z" fill="#7a7a7a" />
      <circle cx="-2.8" cy="0.5" r="1" fill="#333" /><circle cx="2.8" cy="0.5" r="1" fill="#333" />
      <path d="M-2.6 4 q2.6 2 5.2 0" stroke="#a85f3a" strokeWidth="0.9" fill="none" strokeLinecap="round" />
    </g>
  );
}

const SCENES = {
  door: { bg: '#e3f0ff', svg: (
    <g>
      <rect x="14" y="22" width="40" height="58" rx="2" fill="#6aa8e6" />
      <rect x="20" y="28" width="28" height="52" fill="#cfe4fb" />
      <rect x="33" y="40" width="13" height="40" rx="1" fill="#3f7fc4" />
      <circle cx="36" cy="60" r="1.6" fill="#fff" />
      <path d="M60 30 q5 3 5 9" stroke="#f4a93b" strokeWidth="2.4" fill="none" strokeLinecap="round" />
      <Rep x={92} y={42} flip />
    </g>) },
  entry: { bg: '#e6f6ea', svg: (
    <g>
      <rect x="20" y="20" width="38" height="60" rx="2" fill="#7cc497" />
      <path d="M34 24 L58 30 L58 80 L34 80 Z" fill="#2f8a55" />
      <path d="M64 50 L80 50 M74 44 L80 50 L74 56" stroke="#1B5E20" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <Rep x={104} y={42} female />
    </g>) },
  rapport: { bg: '#f1eaff', svg: (
    <g>
      <rect x="36" y="18" width="26" height="15" rx="5" fill="#9b7fd4" />
      <path d="M44 33 l4 6 l3 -6 z" fill="#9b7fd4" />
      <circle cx="44" cy="25" r="1.6" fill="#fff" /><circle cx="49" cy="25" r="1.6" fill="#fff" /><circle cx="54" cy="25" r="1.6" fill="#fff" />
      <Rep x={40} y={52} female />
      <Homeowner x={104} y={54} color="#c98a8a" flip />
    </g>) },
  objection: { bg: '#fdeef0', svg: (
    <g>
      <rect x="34" y="20" width="30" height="20" rx="6" fill="#e07a8c" />
      <path d="M42 40 l4 7 l3 -7 z" fill="#e07a8c" />
      <text x="49" y="34" fontSize="13" fontWeight="800" fill="#fff" textAnchor="middle">!</text>
      <path d="M70 30 l4 4 l8 -8" stroke="#1B5E20" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <Rep x={104} y={50} />
    </g>) },
  inspection: { bg: '#fff3da', svg: (
    <g>
      <rect x="14" y="24" width="50" height="56" rx="2" fill="#e7cfa0" />
      <path d="M22 40 l8 18 M40 30 l6 34 M54 40 l4 28" stroke="#b07b3a" strokeWidth="2" fill="none" strokeLinecap="round" />
      <circle cx="60" cy="40" r="11" fill="#bfe0ff" opacity="0.55" stroke="#3a3a3a" strokeWidth="3.5" />
      <line x1="68" y1="48" x2="78" y2="58" stroke="#3a3a3a" strokeWidth="4.5" strokeLinecap="round" />
      <Rep x={104} y={48} />
    </g>) },
  urgency: { bg: '#ffe7e3', svg: (
    <g>
      <path d="M20 72 L40 32 L60 72 Z" fill="#f0913e" stroke="#d9722a" strokeWidth="2" strokeLinejoin="round" />
      <rect x="38" y="46" width="4" height="14" rx="2" fill="#fff" /><circle cx="40" cy="65" r="2.4" fill="#fff" />
      <circle cx="74" cy="34" r="9" fill="#e0524a" /><path d="M74 30 v4 l3 2" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" />
      <Rep x={104} y={50} female />
    </g>) },
  stage: { bg: '#e2f6f4', svg: (
    <g>
      <rect x="24" y="22" width="38" height="54" rx="3" fill="#5bbcb3" />
      <rect x="30" y="28" width="26" height="42" rx="2" fill="#fff" />
      <rect x="35" y="18" width="16" height="8" rx="2" fill="#2e8c84" />
      <path d="M34 38 l3 3 l6 -6 M34 50 l3 3 l6 -6 M34 62 l3 3 l6 -6" stroke="#2e8c84" strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <Rep x={104} y={48} female />
    </g>) },
  company: { bg: '#e8eafc', svg: (
    <g>
      <path d="M40 18 L64 28 V52 C64 64 53 72 40 76 C27 72 16 64 16 52 V28 Z" fill="#6f7fd6" />
      <path d="M32 48 l5 6 l12 -14" stroke="#fff" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <Rep x={104} y={48} />
    </g>) },
  product: { bg: '#e0f7fb', svg: (
    <g>
      <path d="M16 50 L42 28 L68 50 V78 H16 Z" fill="#54c2d6" />
      <rect x="30" y="60" width="14" height="18" fill="#2b97ab" />
      <rect x="50" y="36" width="18" height="9" rx="2" fill="#f4c150" transform="rotate(-18 59 40)" />
      <Rep x={104} y={48} />
    </g>) },
  pricing: { bg: '#fff6d9', svg: (
    <g>
      <path d="M16 30 L44 30 L70 56 L46 80 L20 54 Z" fill="#f4c150" stroke="#d6a32f" strokeWidth="2" strokeLinejoin="round" />
      <circle cx="30" cy="44" r="4" fill="#fff" />
      <text x="48" y="60" fontSize="18" fontWeight="800" fill="#fff" textAnchor="middle">%</text>
      <Rep x={104} y={48} female />
    </g>) },
  tiedown: { bg: '#e6f6ea', svg: (
    <g>
      <Rep x={36} y={50} />
      <Homeowner x={88} y={52} color="#8aa9c9" flip />
      <path d="M50 60 l16 -2 l8 2" stroke="#caa15f" strokeWidth="5" fill="none" strokeLinecap="round" />
      <path d="M30 28 l4 4 l8 -8" stroke="#1B5E20" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </g>) },
  mindset: { bg: '#ffeede', svg: (
    <g>
      <circle cx="40" cy="46" r="20" fill="none" stroke="#f08a3c" strokeWidth="4" />
      <circle cx="40" cy="46" r="11" fill="none" stroke="#f0b03c" strokeWidth="4" />
      <circle cx="40" cy="46" r="3.5" fill="#e0524a" />
      <path d="M64 22 L48 38 M64 22 l-9 1 M64 22 l-1 9" stroke="#1B5E20" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <Rep x={104} y={48} female />
    </g>) },
  defaultScene: { bg: '#eef1ef', svg: (
    <g>
      <rect x="22" y="20" width="38" height="54" rx="3" fill="#b9c4bf" />
      <rect x="28" y="30" width="26" height="3" rx="1.5" fill="#fff" />
      <rect x="28" y="40" width="26" height="3" rx="1.5" fill="#fff" />
      <rect x="28" y="50" width="18" height="3" rx="1.5" fill="#fff" />
      <Rep x={104} y={48} />
    </g>) },
};

const RULES = [
  ['door',       ['DOOR KNOCK', 'WHAT TO EXPECT', 'ARRIVE', 'KNOCK']],
  ['entry',      ['GAIN ENTRY', 'GAINING ENTRY', 'ENTRY']],
  ['rapport',    ['RAPPORT', 'TRUST BUILDING', 'TRUST &']],
  ['objection',  ['OBJECTION', 'WALK-AWAY', 'STAY AND PITCH', 'STAY-AND-PITCH']],
  ['inspection', ['INSPECTION', 'DOCTOR METHOD', 'WHAT TO LOOK FOR', 'I-E-C', 'DAMAGE']],
  ['urgency',    ['URGENCY', 'CONSEQUENCE', 'TRANSITION TO']],
  ['stage',      ['SET THE STAGE', 'THREE', 'SCRIPT', 'STAGE']],
  ['company',    ['COMPANY', 'PROTECTION', 'PROBLEM', 'WHAT MAKES CPR', 'HOW WE TREAT']],
  ['product',    ['PRODUCT', 'OPTIONS', 'COOLLIFE', 'PROCESS', 'OUR PROCESS', 'TRENCH', 'HYDRO', 'PATCH', 'MASK', 'PRIMER', 'FINISH']],
  ['pricing',    ['PRICING', 'MSRP', 'DISCOUNT', 'SAVINGS', 'TIMELINE', 'STACK']],
  ['tiedown',    ['TIE-DOWN', 'TIE DOWN', 'TODAY', 'INVESTMENT', 'REPRESENTATIVE', 'CLOSE']],
  ['mindset',    ['MINDSET', 'TOP PERFORMERS', 'STICK TO THE SCRIPT']],
];

export function sceneKeyFor(header) {
  const h = (header || '').toUpperCase();
  for (const [key, words] of RULES) if (words.some(w => h.includes(w))) return key;
  return 'defaultScene';
}

// Map section headers to a mascot pose photo (frontend/public/mascot/)
const POSE_RULES = [
  ['roof',        ['INSPECTION', 'DAMAGE', 'WHAT TO LOOK FOR', 'I-E-C', 'DOCTOR']],
  ['writing',     ['PRICING', 'MSRP', 'DISCOUNT', 'SAVINGS', 'INVESTMENT', 'TIMELINE', 'STACK']],
  ['presenting',  ['PRODUCT', 'OPTIONS', 'COOLLIFE', 'PROCESS', 'DEMO', 'TRENCH', 'HYDRO', 'PATCH', 'MASK', 'PRIMER', 'FINISH']],
  ['ok',          ['TODAY', 'CLOSE', 'TIE-DOWN', 'TIE DOWN', 'SIGN']],
  ['folder',      ['COMPANY', 'STORY', 'PROTECTION', 'HISTORY', 'WHAT MAKES CPR']],
  ['armscrossed', ['OBJECTION', 'WALK-AWAY', 'STAY AND PITCH', 'STAY-AND-PITCH']],
  ['pointing',    ['DOOR', 'KNOCK', 'ENTRY', 'ARRIVE', 'SET THE STAGE', 'STAGE', 'SCRIPT', 'GREET']],
  ['thumbsup',    ['MINDSET', 'OVERVIEW', 'TOP PERFORMERS', 'RAPPORT', 'TRUST', 'EXPECT']],
];
export function poseForHeader(header) {
  const u = (header || '').toUpperCase();
  for (const [pose, words] of POSE_RULES) if (words.some(w => u.includes(w))) return pose;
  const all = ['thumbsup', 'pointing', 'writing', 'presenting', 'folder', 'ok'];
  let s = 0; for (let i = 0; i < u.length; i++) s += u.charCodeAt(i);
  return all[s % all.length];
}

export default function LessonArt({ header }) {
  const scene = SCENES[sceneKeyFor(header)] || SCENES.defaultScene;
  const pose = poseForHeader(header);
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: scene.bg, borderRadius: 12, padding: '8px 14px', margin: '18px 0 6px', overflow: 'hidden' }}>
      <svg viewBox="0 0 150 96" width="96" height="60" style={{ flexShrink: 0 }} xmlns="http://www.w3.org/2000/svg">{scene.svg}</svg>
      <div style={{ fontWeight: 800, color: '#0D3B2E', fontSize: 14, flex: 1 }}>{header}</div>
      <img src={`/mascot/mascot-${pose}.png`} alt="" style={{ height: 66, width: 'auto', flexShrink: 0, margin: '-8px -6px -10px 0', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.18))' }} />
    </div>
  );
}
